<div class="order-list-stiky-header" *ngIf="db.scroll_top">
  <!-- <ion-title>Orders</ion-title> -->
  <!-- <ion-title class="margin" *ngIf="db.orders_list">Orders</ion-title> -->
  <div *ngIf="false" class="search__filters">
    <ion-title class="margin p0" *ngIf="db.orders_list">Orders</ion-title>
    <!-- <div class="top__bar">
      <ion-searchbar #search animated [(ngModel)]="db.searchText" (ionChange)="db.search_function()" placeholder="Search orders"></ion-searchbar>
    </div> -->
    <div  #search_dropdown class="d__flex border web__searchbar search_box" [ngClass]="'search_down'?'focused':''">
      <ion-input #search (input)="db.search_function()" name="search" [(ngModel)]="db.searchText"  placeholder="Search Items"></ion-input>
      <ion-icon class="f24" src="assets/icon/search.svg" slot="end"></ion-icon>
    </div>
    <!-- <ion-item class="sort-buttons d__flex sort__buttons">
            <ion-icon class="sort-icon" src="/assets/icon/date-time.svg"></ion-icon>
            <ion-label>Sort by time</ion-label>
            <ion-select interface="popover" placeholder="">
            </ion-select>
    </ion-item> -->
    <!-- <div class="d__flex main_sort">
      <ion-item class="sort-buttons sort__buttons">
        <ion-icon class="sort-icon" src="/assets/icon/sort-by-status.svg"></ion-icon>
        <ion-select interface="popover" placeholder="" (ionFocus)="get_dropdown(get_order_status)" [ngModel]="order_status" (ionChange)="value_changed($event)">
          <ion-select-option *ngFor="let v of get_order_status.options?get_order_status.options:[]" [value]="v.name">{{v.name}}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item class="sort-buttons sort__buttons">
        <ion-icon class="sort-icon" src="/assets/icon/payment-status.svg"></ion-icon>
        <ion-label>Payment Status</ion-label>
        <ion-select interface="popover" placeholder="">
        </ion-select>
      </ion-item> -->
      <!-- <ion-item class="sort-buttons sort__buttons">
      <ion-icon class="sort-icon" src="/assets/icon/customer-type.svg"></ion-icon>
      <ion-label>Sort by Customer Type</ion-label>
      <ion-select interface="popover" placeholder="">
        <ion-select-option value="brown">Brown</ion-select-option>
      </ion-select>
    </ion-item> -->
    <!-- </div> -->
    <!-- <ion-item class="sort-buttons d__flex sort__buttons">
      <ion-icon class="sort-icon" src="/assets/icon/sort-by-status.svg"></ion-icon>
      <ion-label>Sort by Order Status</ion-label>
      <ion-select interface="popover" placeholder="">
      </ion-select>
    </ion-item>
    <ion-item class="sort-buttons d__flex sort__buttons">
      <ion-icon class="sort-icon" src="/assets/icon/payment-status.svg"></ion-icon>
      <ion-label>Sort by Payment Status</ion-label>
      <ion-select interface="popover" placeholder="">
      </ion-select>
    </ion-item>
    <ion-item class="sort-buttons d__flex sort__buttons">
      <ion-icon class="sort-icon" src="/assets/icon/customer-type.svg"></ion-icon>
      <ion-label>Sort by Customer Type</ion-label>
      <ion-select interface="popover" placeholder="">
        <ion-select-option value="brown">Brown</ion-select-option>
      </ion-select>
    </ion-item> -->
  </div>
  <div class="order-list-filters">
    <div class="all-order mouse" (click)="db.filterOrder('all')">
      <h6 [ngClass]="db.filters.all == true?'active-filter':'no-filter'">All</h6>
    </div>
    <div class="new-order mouse" (click)="db.filterOrder('new')">
      <h6 [ngClass]="db.filters.new == true?'active-filter':'no-filter'">New</h6>
    </div>
    <div class="completed-order mouse" (click)="db.filterOrder('complete')">
      <h6 [ngClass]="db.filters.complete == true?'active-filter':'no-filter'">Completed</h6>
    </div>
    <div class="completed-order mouse" (click)="db.filterOrder('Cancelled')">
      <h6 [ngClass]="db.filters.Cancelled == true?'active-filter':'no-filter'">Cancelled</h6>
    </div>
    <!-- <div class="completed-order mouse" (click)="db.filterOrder('Refun')">
      <h6 [ngClass]="db.filters.Refun == true?'active-filter':'no-filter'">Refun</h6>
    </div> -->
    <!-- <div *ngFor="let item of sales_type" class="completed-order mouse" (click)="db.filterOrder(item.name)">
      <h6 [ngClass]="db.active_sales_type == item.name ?'active-filter':'no-filter'">{{item.name}}</h6>
    </div> -->
  </div>
</div>
<div class="Fields-9" *ngIf="!db.ismobile">
  <div class="table__data fnt-11 d__flex table__header">
    <div class="txt-center">
      <!-- <ion-checkbox class="check__box" (click)="check_box = !check_box"></ion-checkbox> -->
      <!-- <ion-icon class="fnt-14" name="square-outline"></ion-icon> -->
    </div>
    <div class="">Order Id</div>
    <div class="">Order Date</div>
    <div class="">Customer Name</div>
    <div class="">Buyer Center</div>
    <div class="txt-right pr15">Order Amount</div>
    <div class="txt-right pr15">Seller Amount</div>
    <div class="">Order Status</div>
    <div class="">Payment Status</div>
  </div>
  <div [ngClass]="db.scroll_top?'orderss__list':'orderss_list'" #scrollMe (scroll)=" this.db.p_loadMoreData ? onScroll($event) : null" *ngIf="db.pendingorders.length != 0">
    <div class="main-item mouse animated fadeInUp" *ngFor="let item of orders_list;let i =index" (click)="order_list(item)">
      <div class="table__data align-c d__flex table__items">
        <div class="txt-center">
          <!-- <ion-checkbox [checked]="check_box" class="check__box box__icon"></ion-checkbox> -->
          <!-- <ion-icon class="box__icon" name="square-outline"></ion-icon> -->
        </div>
        <div class="order_id">
          <p class="m-0">{{item.name}}</p>
        </div>
        <div>
          <p class="m0" *ngIf="item.order_date || item.order_time">{{item.order_date | date: 'MM/dd/yyyy'}}</p>
          <!-- <P>{{moment(item.creation).fromNow()}}</P>  -->
        </div>
        <!-- <div><span class="order_status" [class.delivered]="item.status == 'Delivered'" [class.success]="item.status == 'Completed'" [class.canceled]="item.status == 'Cancelled'" [class.inprogress]="item.status == 'In Process'" [class.placed]="item.status == 'Placed'"  [class.order-packed]="item.status == 'Packed'" [class.shipped]="item.status == 'Shipped'">{{item.status}}</span></div> -->
        <div class="txt_capital ">{{item.customer_name}}</div>
        <div class="">{{item.center}}</div>
        <div class="txt-right pr15 open_sans__font"> {{item.total_amount | currency: db.currency}}</div>
        <div class="txt-right pr15 open_sans__font"> {{item.total_amount_for_vendor | currency: db.currency}}</div>
        <div><span class="order_status"  [class.success]="item.status == 'Completed'" [class.canceled]="item.status == 'Cancelled'" [class.Pending]="item.status == 'Pending'">{{item.status}}</span></div>
        <div class="d__flex payment__status"><span class="dot" [class.paid-b]="item.payment_status == 'Paid'" [class.pending]="item.payment_status == 'Pending'" [class.authorized]="item.payment_status == 'Authorized'" [class.partialypaid]="item.payment_status == 'Partially Paid'"></span>
          <p class="m0 p0" [class.paid-c]="item.payment_status == 'Paid'" [class.pend]="item.payment_status == 'Pending'" [class.auth]="item.payment_status == 'Authorized'" [class.partial]="item.payment_status == 'Partially Paid'">{{item.payment_status}}</p>
        </div>
        <!-- <div class="">{{item.order_from}}</div> -->
      </div>
    </div>
  </div>
  <div class="pl10" *ngIf="db.pendingorders.length == 0 && !db.is_order">
    <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]">
      <ion-label>
        <h3 class="d__flex just-s">
          <ion-skeleton-text animated style="width: 20px; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 15%; height: 16px"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 10%; height: 16px"></ion-skeleton-text>
        </h3>
      </ion-label>
    </ion-item>
  </div>
</div>

<ion-list *ngIf="db.ismobile">
  <ion-item *ngFor="let item of orders_list.order_items">
    <div class="w-100 orders">
      <div class="d__flex just-s order-mb"><span>{{item.name}}</span> <span class="price-color open_sans__font">{{item.total_amount | currency:db.currency}}</span></div>
      <div class="d__flex just-s order-date-mb fnt-11"><span>{{item.order_date | date: 'MM/dd/yyyy' }} {{item.order_time}}</span> <span>Order {{item.type}}</span></div>
      <div class="d__flex just-s status-mb fnt-13"><span>Items : {{item.Items.length}}</span>
        <div [class.order-shipped]="item.status == 'Shipped'" [class.ready-to-pack]="item.stauts == 'Ready To Pack'" [class.order-packed]="item.status == 'Packed'" [class.order-placed]="item.status == 'Placed'" [class.order-completed]="item.status == 'Completed' || item.status == 'Delivered'">
          {{item.status == 'Placed'?'Order':''}} {{item.status}}</div>
      </div>
    </div>
  </ion-item>
</ion-list>

<app-no-record-found *ngIf="db.pendingorders.length == 0 && db.is_order" [column]="true" height="calc(100vh - 210px)" heading="There’s no orders found" [image]="'assets/icons/order-null.svg'"></app-no-record-found>

<!-- <div class="wallet__img" *ngIf="db.pendingorders.length == 0 && db.is_order">
  <img src="assets/icons/order-null.svg" alt="">
  <p>No Orders Found</p>
</div> -->
